/** Returns the jsx for custom event type */
import React, {useState} from "react";
import moment from "moment-timezone";
import PromosInEvents from "./PromosInEvents";
import SocialsInEvents from "./SocialsInEvents";
import {CustomEventIcon, ReservationIcon} from "../../../../utils/svg";
import ReservationModal from "../../../../components/ReservationModal";
import { connect } from "react-redux";
import { formatTime } from "../../../../utils/utils";
import { svgMap } from "../../../../utils/constants";
import * as svgs from "../../../../utils/svg";
import ChannelsList from "../../../../components/ChannelsListPopup";
import channels from "../../../../utils/channels";
import RenderChannel from "./standardEvents/StationsinEvents";

const RenderCustomEvent = props => {
    const [showReservationModal, setShowReservationModal] = useState(false);
    const [showChannels, setShowChannels] = useState(false);
    const timeFormat = props.time_format === '24H' ? 'HH:mm' : 'h:mm A';
    const SvgIcon = svgs[svgMap[props.sport_object?.short_name]|| "OtherIcon"];
    const renderChannel = (selectedStationId, isFavorite) => {
      let station;
      for (let stationIndex in props.stations) {
        if (selectedStationId === props.stations[stationIndex].id) {
          station = props.stations[stationIndex];
          break;
        }
      }

      let match = findMatch(station);
      let iconPath = "./default.svg";
      let stationName = station?.name;
      if (match) {
        let obj = channels[match];
        if (obj.name) {
          stationName = obj.name;
          if (obj.icon) iconPath = obj.icon;
        } else iconPath = obj;
      }

      return (
          <RenderChannel
              stationName={stationName}
              iconPath={iconPath}
              {...props}
              showChannelsPopup={() => setShowChannels(true)}
              isFavorite={isFavorite}
              moreStationsCount={props.stations.length - 1}
              dashboardtitle={iconPath === "./default.svg"}
          />
      );
    };
    const selectStation = preferredStationId => {
      if (!props.stations) return null;
      if (preferredStationId) {
        return renderChannel(
            preferredStationId,
            favIds.includes(preferredStationId)
        );
      }
      for (let stationIndex in props.stations) {
        if (!favIds.includes(props.stations[stationIndex].id))
          continue;
        return renderChannel(props.stations[stationIndex].id, true);
      }
      if (props.stations[0]) return renderChannel(props.stations[0].id, false);
      return null;
    };
    const findMatch = station => {
      for (let chName in channels) {
        if (station?.name?.toLowerCase()?.includes(chName.toLowerCase())) {
          return chName;
        }
      }
      return null;
    };


  let favIds = [];
    props.favoriteStations.map( (station) => {
      favIds.push(station.id)
    })

    let to = null;
    let event_icon = "";

    if (props.type === "reservation" && props.end_time && props.end_time !== props.start_time){
        let sameDay = moment(props.start_time).tz(props.timezone).isSame(moment(props.end_time).tz(props.timezone), 'day');
        to = (
            <React.Fragment>
                <span className="fs-body2"> to</span>
                <br />
                <span className={"text-nowrap " + (sameDay ? "" : "fs-body3")}>{moment(props.end_time).tz(props.timezone).format(sameDay ? timeFormat : "D MMMM " + timeFormat)}</span>
            </React.Fragment>
        );
    }
    if (props.type === "custom"){
      if (props.sport_object && (props.event_type || "").toLowerCase() == "sport"){
        event_icon = <SvgIcon alt={props.sport_object?.short_name} className="event-item__sport-type" />;
      } else {
        event_icon = <CustomEventIcon alt="custom event" className="event-item__sport-type"/>;
      }
    } else{
      event_icon = <ReservationIcon alt="reservation" className="icon-reservation" />;
    }

    // showChannels = props.stations.length > 0;
    return (
        <React.Fragment>
          <div className="p-3 col-6 d-flex m-0 align-items-center">
            {props.children}
            <div className="d-flex justify-content-center align-items-center">
              {event_icon}
            </div>
            <div
                {...props.type === "reservation" && {className: "element--clickable w-100", title: 'Click to see details', onClick: () => setShowReservationModal(true)}} >
                <span className="limit-to-2lines">{props.name}</span>
                {props.description.length > 0 && (
                    <span className="limit-to-2lines fs-body2 text--gray8">{props.description}</span>
                )}
            </div>
          </div>
          <div className="d-flex col-1 align-items-center flex-column justify-content-center event-item__match-times">
            <div
                className="fs-body1"
                title={props.timezone + ' time (UTC: ' + moment(props.start_time).utc().format('LLL') + ')'}
            >
                {formatTime(props.start_time, props.time_format, props.timezone)}
                {to}
            </div>
          </div>
          <div className="eventlist-channels col d-flex align-items-center justify-content-center fs-caption2">
            {selectStation(props.pref_station)}
          </div>
          {showChannels ? (
              <ChannelsList
                  {...props}
                  show={showChannels}
                  cancelModal={() => setShowChannels(false)}
              />
          ) : null}
          {/* Promos in events disabled for now */}
           <PromosInEvents />
          {props.socials && <SocialsInEvents />}
          { showReservationModal &&
            <ReservationModal {...props} show={showReservationModal} cancelModal={() => setShowReservationModal(false)} />
          }
        </React.Fragment>
    );
};

const mapStateToProps = state => {

  return {
    favoriteStations: state.favoriteStations,
    timezone: state.timezone,
    time_format: state.time_format
  };
};

export default connect(mapStateToProps)(RenderCustomEvent);
